export default {
  sheetCover: {"action":"智能主图","title":"识别委托书主图","hint":"选择含完整正面款式或 ColorWay 的图片。Qwen 定位后从原图裁切，不重绘；确认后仅用于页眉主图，原资料保持。","source":"来源图片","result":"主图预览","waiting":"点击识别，核对款式是否完整后再确认。","recognize":"Qwen 识别","confirm":"设为主图","failed":"主图识别失败，请稍后重试","noResult":"未找到可靠的完整款式，请更换图片","sourceMissing":"来源图片不存在或格式不支持","busy":"此委托书正在识别，请稍后重试"},
  plmRefresh: { enlarge: '查看原图', designImages: '设计图片', imageHint: '选择缩略图切换，点击大图查看原图。', imagePosition: '{current} / {total}', imageFailed: '图片加载失败', imageLoading: '图片加载中' },
  packHeader: {supplierRequired:'待生产管理填写供应商',supplierSearch:'输入六位供应商代码或名称',supplierNotFound:'未找到供应商，请核对代码或名称',supplierLoadFailed:'供应商查询失败，请重新搜索', batch:'{n}次',edit:'编辑款式信息',finish:'完成编辑',brandMismatch:'品牌须与款号前两位一致。',categoryMismatch:'品类须与款号第3–4位一致。',chooseGender:'请从性别列表选择。',supplierOwner:'供应商由生产管理填写。',sourceChanged:'上游资料有更新，本地纠正已保留，请商品企划核对。' },
  orderInfo: { title: '订货信息' },
  sizeImport: { selectFirst: '选择前 {max} 项' },
  manualStyle: {'title': '颜色与尺码', 'sizes': '尺码范围', 'sizeInput': '输入尺码后按回车', 'sizesPending': '待商品企划设置尺码', 'manualOnly': '仅手工款可在本系统修改款式及订货资料。', 'sizeInUse': '该尺码已有资料，请先处理对应资料后再移除。', 'colorInUse': '该颜色已有资料，请先处理对应资料后再移除。', 'unknownColor': '请选择颜色列表中的颜色。', 'chooseSize': '请从本款尺码范围选择样衣尺码。', 'chooseColor': '请选择商品企划已设定的款式颜色。', 'duplicate': '颜色和尺码不能重复。'},
  draftReview: {
    title: '资料已更新，待核对', review: '核对差异', collapse: '收起差异',
    fieldsHint: '以最新资料为基础，勾选需要保留的填写。',
    structureHint: '行或规格已变更。请保存填写副本，核对最新资料后重新填写。',
    field: '字段', original: '原值', mine: '我的填写', latest: '最新资料', keepMine: '保留我的填写',
    useLatest: '使用最新资料', apply: '应用选择', saveCopy: '保存填写副本', copyName: '未保存的填写',
    discardConfirm: '使用最新资料会替换本表未保存的填写。是否继续？', row: '第 {n} 行', item: '第 {n} 项',
    parts: { sourceHeader: '款式来源资料', supplierHeader: '供应商', plannerStyle: '款式与订货资料', qc: 'QC', basicinfo: '款式信息', colorway: '配色', designmemo: '设计备注', orderinfo: '订货信息', fabric: '面料', trim: '辅料', size: '尺寸', usageFabric: '面料用量与成本', usageTrim: '辅料用量与成本' },
    fields: { styleCd: '款号', styleNm: '品名', brandCd: '品牌', originalStyleNo: '原款号', genderCd: '性别', productYear: '年度', season: '季节', salesMonth: '上市月', finalGrade: '商品等级', businessType: '业务类型', productType: '商品类型', styleKind: '款号种类', characteristic: '特性参数', productionCategory: '生产品类', productionType: '生产类型', mdpType: 'MDP类型', mdpStartDate: 'MDP开始日期', salePrice: '售价', quantities: '订货数量', qty: '数量', people: '人员', designerId: '设计师', plannerId: '商品企划', purchasingId: '面辅料采购', productionId: '生产管理', patternId: '版师', cadId: '版师', qcTypeCd: 'QC 类型', qcTypeNm: 'QC 类型名称', factoryNm: '工厂', countryCd: '生产地', krPicEmpNo: '韩方负责人工号', krPicEmpNm: '韩方负责人', qcDate: '检验日期', baseSizeCd: '样衣尺码', resultCd: '检验结果', resultNm: '检验结果名称', mainMaterial: '面料', mainBodyContent: '面料成分', note: '备注', rejectSeq: '驳回次数', rejectReason1: '驳回原因 1', rejectReason2: '驳回原因 2', rejectReasonMemo: '驳回说明', standardSpec: '标准尺寸', sampleSpec: '实测尺寸', qcDifference: '偏差', side: '意见来源', content: '意见', authorEmpNo: '填写人工号', authorNm: '填写人', sizeChecks: '尺寸实测', comments: 'QC 意见', samplePhase: '委托书阶段', stdSize: '样衣尺码', stitchDensity: '针距', remark: '备注', patternModuleNo: '版型模块号', moduleModelCd: '参考委托书编号', moduleStyleCd: '参考款号', contentKo: '韩文备注', contentEn: '英文备注', washingInfo: '洗水说明', colors: '配色', cd: '颜色代码', nm: '颜色名称', receivingDueDate: '入库要求日期',
      categoryCode: '小分类', row: '行资料', usedPartCd: '使用部位', materialGroupCd: '面料分类', materialCode: '面料代码', materialNm: '面料名称',
      materialAlias: '面料别名', materialMemo: '面料备注', colorMatchPartCd: '配色部位', tagColorCd: '适用颜色', tagColors: '适用颜色',
      vendorNm: '供应商', composition: '成分', finishing: '后整理', width: '幅宽', unit: '单位', yardage: '预估用量', realYardage: '实际用量',
      unitPrice: '单价', unitPriceCurrency: '币种', weight: '克重', weightUnit: '克重单位',
      subMaterialTypeCd: '辅料种类', subMaterialCd: '辅料代码', contents: '辅料名称', usedPart: '使用部位', memo: '技术备注',
      yardageUnit: '用量单位', isCommon: '全色共通', bomGroup: '辅料分组', sizes: '尺码规格', sizeCd: '尺码', gauge: '规格', gaugeUnit: '规格单位',
      currency: '币种', isUsed: '使用', colorNm: '颜色名称', patternPartCd: '测量部位代码', patternPartNm: '测量部位', measurement: '测量方法',
      size: '基准尺寸', values: '分尺码尺寸', value: '尺寸值', tolLeft: '左偏差', tolRight: '右偏差', tolPlus: '上公差', tolMinus: '下公差',
    },
  },
  sheetPhase: {
    PROTOTYPE: "评价会 · Prototype",
    TRADESHOW: "订货会 · TradeShow",
    MAIN: "大货 · Main",
  },
  sheetDetail: {
    samplePhase: "委托书阶段",
    recordVersion: "记录版本",
    recordNo: "记录 {n}",
    expandNavigation: "展开导航",
    collapseNavigation: "收起导航",

    personNumberOnly: "工号 {no}（姓名待补）",
    personUnassigned: "待分配",
    detailsAndPeople: "款式资料与负责人",
    assignees: "款式担当",
    sourceDetails: "来源资料",
    orderFair: "订货会",
    productNamePending: "商品名待补充",
    patternOwner: "尺寸由版师 {name} 填写，当前视角可查看。",
    patternOwnerNamed: "尺寸由版师 {name} 填写，当前视角可查看。",
    patternOwnerAnon: "尺寸由版师填写，当前视角可查看。",
    sections: "委托书内容",
    confirmed: "已确认",
    pending: "待确认",
    confirmedBy: "确认人：{name}",
    backToEdit: "返回编制",
    previousPage: "上一页",
    nextPage: "下一页",
    pageSelect: "预览页码",
    pageNo: "第 {n} / {total} 页",
    fitWidth: "适应宽度",
    preparingPrint: "准备导出…",
    printHint: "导出全部 9 页。在打印窗口选择“另存为 PDF”，使用 A4 横向、无页眉页脚；价格不会出现在打印件中。",
    printFailed: "导出所需的图片或字体尚未准备好。请检查连接后重试；当前资料仍保留。",
    pendingItems: "最终确认前待补事项",
    uploadTargetChanged: "上传位置已变更。请移除待上传文件，确认位置后重新选择。",
    uploadDestination: "上传至 {name}",
    retryUpload: "重试上传",
    discardFile: "移除待上传文件",
    replaceFileHint: "新文件上传成功后会替换现有文件。",
    libraryImage: "辅料库图片。本单上传图片后将优先使用本单图片。",
    recognitionSource: "识别资料来源",
    recognitionSourceHint: "选择一份文件的面辅料资料进行核对；各文件的核对修改分别保留，图片仍按所选去向上传。",
    draftMismatch: "设计稿款号为 {draft}，当前款号为 {style}。请确认该稿件可以作为本款参考资料后再导入。",
    draftMismatchTitle: "核对稿件款号",
    useReference: "作为参考资料导入",
    pageTarget: "{name} 的导入去向",
  },
  sheetEdit: {
    rowDeleted: '已删除',
    undoDelete: '撤销删除',

    autopending: "等待保存",
    autosaving: "正在保存…",
    autosaved: "已保存",
    autofailed: "未保存",
    recoveryAvailable: "发现未保存的内容，当前资料已更新。",
    recoverDraft: "恢复未保存内容",
    useServerDraft: "使用当前资料",
    localDraftUnavailable: "本地草稿暂时无法保留，请确认保存成功后再离开。",

    unsavedTitle: '有尚未保存的内容',
    leaveMessage: '离开当前编辑区会放弃尚未保存的修改。是否继续？',
    discardChanges: '放弃修改并继续',
    keepEditing: '继续编辑',
    prefillCloseMessage: '关闭后将放弃本次选择的来源与预填范围。是否继续？',
    discardSelection: '放弃本次选择',
    savingWait: '正在保存或上传，请稍候。',
    saveBeforeAction: '请先保存当前修改，再进行确认或提交。',
    importWriting: '正在写入已核对的面辅料资料…',
    importWriteFailed: '已保存 {n} 个文件，面辅料资料尚未写入。请继续导入，无需重新上传这些文件。原因：{reason}',
    importUploadFailed: '已保存 {n} 个文件，其余内容尚未导入。请检查后继续导入。原因：{reason}',
    retryImport: '继续导入',
    importDataOnly: '确认并写入资料',
    importCloseMessage: '尚有未导入的内容。放弃后，已上传的文件仍会保留在委托书中。',
    discardImport: '放弃剩余内容',
    keepImporting: '继续核对',
    recognitionKept: '已保留 {first} 的识别结果；{next} 仅导入图片和原稿。如需识别后者，请单独导入。',
    retryFile: '重试',
    sizesEmptyEditable: '尚未填写尺寸。请从主数据带入或新增行，填写部位与尺寸值后保存。',
    sizesEmptyReadonly: '尚未填写尺寸，由版师补充。当前账号可查看。',
    trimSaveStructure: '请先保存辅料行的增删或排序，再上传图片。',
    packNeedsRecheck: 'Tech Pack 需重新核对',
    cancelOldConfirmation: '取消原确认',
    stageOwner: '由「{roles}」确认',
    stageConfirmedBy: '已由 {name} 于 {date} 确认',
    stageOwnerByRound: 'QC 担当按轮次分配，在 QC 明细行上指定',
  },
  "ux": {
    "release0205": "手工款仅在实际改号后显示原款号，由系统记录并只读展示，新建和普通资料修改不产生原款号。",
    "release0204": "款式加载失败可重新加载；发布前先完成构建与检查，缩短服务中断，保留原款式和草稿。",
    "release0203": "已发布手工款支持修改后再次发布，保留下游资料，提示颜色尺码冲突。",
    "release0202": "数量表格只保留复制模板到Excel，简化填写与粘贴说明。",
    "release0201": "季节固定为1–8，商品颜色显示代码和英文名。",
    "release0200": "任务列表分页与岗位待办；新建款号只创建全新款式，未传SAP的手工款可原单纠正；按品牌选颜色、按品类选尺码，面料配色使用中国E/B代码。",
    "release0200rc1": "候选测试版：商品企划手工建款与订货资料维护、六岗协作、资料纠错与保存保护；补录订货信息保留前序确认，已批准的委托书不再重复提示送审。",
    "release0193": "设计稿上传后可在图片上方替换或删除，PDF与图片支持重新上传；详细图片和原稿的添加、删除入口常显。",
    "release0192": "01 设计节工具栏的「上传资料」按钮移除（与各上传区入口重复）；上传与 PDF 拆页都走图片资料页各区入口。",
    "release0191": "面料表止于面料备注，幅宽、单位、用量与价格集中在用量与成本；补齐自动保存及连续保存保护，Tech Pack 标题与按钮统一为各环节共用样式。",
    "release0190": "面料与辅料按明细统一列在用量与成本，保留成本参数与冻结快照。",
    "release0180": "调整版型尺寸、配色表与颜色选择，优化 Tech Pack 顶部结构。",
    "release0170": "调整委托书信息卡与审批操作，预填入口归入面辅料，复制资料不带单价。",
    "release0169": "品名显示在款号后面；信息卡、列表与建单弹窗的「临时编号」标记移除（占位编号的重新编号仍待 SP0120）。",
    "release0168": "信息卡行高压紧，标题下不再显示品名小字。",
    "release0167": "信息卡第二行六个字段与第三行六担当同宽对齐，第一行各项统一加粗标题格式（款号仍最大）。",
    "release0166": "款号信息卡改为三行结构：品牌·年季·款号·设计师一行，委托类型/编号/日期/零售价/事前成本/成本率一行，六担当（含面料/辅料分列）底部一行，品牌显示全名。",
    "release0165": "款号信息卡重排：标题栏独占整行，品牌/年度/季节/设计师一行呈现，其余属性四列排布，六担当移到底部整行。",
    "release0164": "款号信息卡视觉规整：字段统一为标签在上、值在下，年度季节改为标题旁徽标，空值弱化、长值悬停查看；右上角「TECH PACK 预览」按钮移除，入口只留左侧导航。",
    "release0163": "Tech Pack 页顶部信息卡与其它节完全一致，事前成本与成本率恢复常显。",
    "release0162": "Tech Pack 页恢复与其它节完全一致的页面结构：六节导航常驻左侧原位，不再收窄或悬浮。",
    "release0161": "Tech Pack 预览的序号导航改为悬浮条，不再压缩预览宽度，内容位置与之前完全一致。",
    "release0160": "设计板块改为「图片资料 / 主信息」两页签，上传收拢为一个入口；Tech Pack 预览保留序号窄导航随时跳节；看板卡片对齐规则、待创建入口常驻、登录回跳修复与菜单收窄。",
    "release0154": "委托书信息卡分为款式资料和六名担当，售价成本集中在左侧，担当以两行常显；收窄六节导航，为资料编辑留出更多空间。",
    "release0153": "设计板块新增“上传 FG 资料”入口，支持查看与替换；FG 图片在 Tech Pack 封面与设计图稿并列显示，上传失败可重试。",
    "release0152": "中国区数量统一按颜色与尺码查看，移除分国别数量；Tech Pack 去掉对应独立页，新建委托书固定使用中国数量。",
    "release0151": "调整委托书顶部信息：突出款号、商品名与年度季节，订货会单独显示；成本与售价融入信息栏，资料及负责人采用紧凑排列。",
    "release0150": "编辑委托书时自动收起导航，资料预填归入设计区；支持自动保存与未保存草稿恢复，Tech Pack 连续预览。新增评价会、订货会、大货阶段标注，与数字记录版本分开管理。",
    "release0142": "修正详情页空字段对齐，删除重复流程说明；首版暂不开放在线商品信息与 USP·设计意图，同步调整预填、设计提交检查和资料进度。",
    "release0141": "修正我的任务列表对齐：各分组使用相同列宽，表头与内容对齐；统一文字、行距和单元格留白，窄窗口下各分组一起横向滚动。",
    "release0140": "完成最终订货对接收尾：商品企划可按款分派版师，版师从任务列表处理用量和尺寸；联测按品牌与专用订货会开放。保留发送前检查、重复推送保护、接收记录和测试资料修正。",
    "release0130": "按确认原型调整委托书详情和 Tech Pack：保留主导航、收起编制侧栏，支持分页与适应宽度；可查看本款的人员可导出，生产管理负责最终确认。导出等待图片与字体就绪，失败可重试；负责人、辅料图片、上传与多文件识别入口同步完善。",
    "adminTitle": "系统管理",
    "adminDesc": "维护人员与角色、查看业务连接状态，并切换用户视角检查操作流程。",
    "adminCounts": "已配置 {users} 个账号、{roles} 个角色。",
    "loadFailed": "暂时无法读取管理信息，请稍后刷新。",
    "manage": {
      "brands": "品牌管理",
      "users": "人员管理",
      "roles": "角色权限",
      "connections": "业务连接",
      "about": "关于系统",
      "assignments": "款式负责人"
    },
    "manageDesc": {
      "brands": "登记并启用当前品牌，控制业务资料的可见范围。",
      "users": "设置角色、可见品牌与账号状态。",
      "roles": "按角色配置操作权限，同角色人员使用相同权限。",
      "connections": "了解资料读取、委托书发送和任务接收的当前状态。",
      "about": "查看软件版本、更新记录与后续计划。",
      "assignments": "为已准备的款式指定具体负责人，查看人员分配情况。"
    },
    "testGuideTitle": "上线前流程测试",
    "testGuide": "使用顶部“切换测试视角”选择具体人员，检查其任务和操作权限。测试操作使用该人员的业务身份，并记录实际操作者。完成后返回管理员。",
    "testView": "切换测试视角",
    "allBrands": "全部品牌",
    "testingAs": "测试视角：{name}",
    "returnAdmin": "返回管理员",
    "language": "界面语言",
    "rolesTitle": "角色权限",
    "rolesDesc": "按角色配置操作权限；在人员管理中为每位人员设置一个角色与可见品牌。",
    "roleMembers": "{count} 位人员",
    "adminProtected": "管理员权限由系统维护，避免误改后无法管理账号。",
    "roleEffect": "保存后，该角色的所有人员立即使用新权限。",
    "saveRole": "保存角色权限",
    "saved": "角色权限已保存",
    "discardPermissions": "当前角色有未保存的修改，是否放弃？",
    "roleSaveConfirm": "将更新“{role}”的权限，影响 {count} 位人员。确认保存？",
    "responsibilities": "查看资料责任分工与审批规则",
    "permissionGroup": {
      "sheet": "委托书与设计审批",
      "spec": "材料与尺寸",
      "qc": "质量检查",
      "sap": "委托书发送",
      "cost": "成本参数",
      "submaterial": "辅料库",
      "master": "基础资料",
      "integration": "业务连接检查",
      "admin": "系统管理",
      "responsibility": "人员分工"
    },
    "tasksTitle": "我的任务",
    "designerJourney": "从 SAP 款号创建委托书，或先用设计师款号准备设计稿，后续关联正式款。",
    "parallelTasks": "按负责的款式补充资料；设计、面辅料采购与生产准备可同时进行。",
    "myAssignments": "分配给我的委托书",
    "brandSheets": "品牌内全部委托书",
    "mineOnly": "只看我的任务",
    "prepareTask": "准备测试任务",
    "businessType": "业务类型",
    "designStatus": "设计审核状态",
    "nextAction": "下一步",
    "unassigned": "待指定",
    "noAssignedTasks": "当前没有符合条件的任务。可切换查看品牌内全部委托书；新任务由前序业务确定后下发。",
    "designApproved": "设计已批准",
    "nextPurchase": "补充面料与辅料规格、单价并确认采购资料",
    "nextPattern": "补充基准尺寸与面辅料用量",
    "technicalNext": { "trimBom": "填写辅料技术信息", "size": "填写基准尺寸", "cost": "填写面辅料用量", "deviation": "填写尺寸偏差" },
    "technicalComplete": "本人技术资料已完成",
    "nextProduction": "核对生产资料并最终确认 Tech Pack",
    "connectionsTitle": "业务连接",
    "connectionsDesc": "查看最近的业务结果与接入进度。历史成功记录和网络检查分别说明，避免误判为已经全部接通。",
    "colTime": "时间",
    "colStyle": "款号",
    "colOperation": "接口",
    "colStatus": "状态",
    "colTotal": "耗时",
    "noRecords": "暂无记录",
    "refreshRecords": "刷新记录",
    "sapRead": "款式资料读取",
    "sapReadDesc": "用于按款号读取颜色、尺码、企划数量等资料。",
    "sapSend": "委托书发送",
    "sapSendDesc": "发送确认后的委托书到业务系统。发送失败时需排查原因并完成复测。",
    "hasSuccessRecord": "已有成功记录",
    "notVerified": "尚未验证",
    "sendNeedsFix": "最近发送失败，待处理",
    "lastSuccess": "最近成功记录：{at}",
    "lastRecord": "最近业务记录：{at}",
    "finalOrders": "订货系统接收",
    "orderIntakeDisabled": "已停用",
    "orderIntakeSapSource": "款式与订货资料统一从 SAP 接收，员工在款式工作台处理任务。原订货系统接收记录保留。",
    "orderLookupSeparate": "现有订货会查询可用于准备资料；最终结果推送仍需单独对接。",
    "awaitIntegration": "待对接",
    "reorders": "加单任务 · 5日",
    "reordersDesc": "接收自社分析的加单建议。上游正在完善，接入时间尚未确定。",
    "planned": "计划接入",
    "networkTitle": "资料通道检查",
    "networkScope": "此检查只确认网络通道可达，不读取或发送业务资料，也不验证业务账号。",
    "networkOk": "网络通道可达",
    "networkFailed": "网络通道暂不可达，请联系维护人员",
    "checkNetwork": "检查网络通道",
    "sapConfigured": "连接资料已配置",
    "sapNotConfigured": "连接资料尚未配置完整",
    "technicalDetails": "维护人员诊断详情",
    "currentStatus": "当前可用范围",
    "currentStatusDesc": "测试验收版本提供按本人或授权团队查看的款式工作台、资料导入与编辑、设计审批、工艺单、面辅料管理、人工加单及供应商协作。SAP款式自动接收首批限定ND／2027，真实资料和担当核对后启用；设计草稿后续由ARCA承接。管理员测试视角保留，正式人员与生产数据切换另行安排；SAP回传及集团邮件仍待联调和配置。",
    "futurePlan": "后续计划",
    "futurePlanDesc": "完成 ND、EE 各岗位与 PDF 验收，核定正式分工并完成 SAP 传送对账。十月底稳定测试后迁移至独立域名；继续对齐上游担当人账号，加单建议随上游进度接入。在线商品信息与 USP·设计意图留待后续完善和验收后开放；多级审批与委托书改版另行确认。",
    "release0222": "统一各页面的字号、行高、表格与按钮样式，调整操作间距和提示文字对比，完善文件选择及行内操作。",
    "release0221": "调整登录页顶部导航与版权信息，补充项目介绍和企业微信登录帮助。",
    "release0220": "更新设计工作室登录首页，使用工作室主图和 design 粗体、sheet 细体文字标识；继续通过企业微信扫码登录。",
    "release0212": "Design Sheet 登录页直接提供企业微信二维码，扫码后返回原页面；支持二维码刷新与备用登录入口。",
    "release0211": "管理员切换测试视角后，继续核验本人的企业微信登录状态；门户退出或更换身份时结束测试会话。",
    "release0210": "新增 SAP 模板批量建款、企业微信登录与员工身份绑定；版师统一负责技术资料，管理员可调整品牌设计审批人。加强传送结果核对、重复发送保护及品牌日志隔离。",
    "releaseHistory": "软件更新记录",
    "release010": "管理员独立首页、角色权限配置、限时测试视角、人员任务列表与业务连接说明。",
    "release012": "增加最终订货接收、推送前检查和重复推送保护，按品牌及基础分工生成任务。测试期间可修正资料或撤回错误接收，保留原始结果和修改履历。",
    "release0121": "订货任务按已确认的业务品类显示，分工完整时不再提示商品企划补选品类；调整负责人时保留原有分类。",
    "release0122": "修正空尺寸完成状态、资料变更后的重新确认、编辑草稿保护、保存反馈及导入失败恢复；辅料图片随原行关联，统一面辅料用语。Tech Pack 新布局与导出范围仍待原型确认。",
    "release011": "新增品牌管理与启用品牌隔离；商品企划维护基础分工及款式负责人。订货数量仅供查看，取消重复确认。",
    "release091": "修复部署路径下的登录与续期请求，补充启动和真实环境检查。",
    "release090": "首个测试版本上线，开放委托书、审批、材料和 Tech Pack 功能。",
    "build": "构建",
    "demoNotice": "演示资料：用于流程测试，内容不作为实际生产依据。",
    "startMaterials": "导入设计资料",
    "peopleTitle": "本款负责人",
    "assignPeople": "指定本款负责人",
    "assignPeopleDesc": "每款各指定一位设计师、商品企划、面辅料采购和生产管理。面料与辅料使用同一位采购负责人。",
    "packReadiness": "Tech Pack 就绪核对",
    "packOwner": "以下确认完成后，由生产管理核对预览并最终确认。",
    "packReady": "资料确认已齐备，可核对预览后最终确认。",
    "waitDesignApproval": "等待设计审核通过",
    "finalConfirm": "最终确认 Tech Pack",
    "finalConfirmed": "Tech Pack 已最终确认",
    "waitProductionConfirm": "等待生产管理最终确认",
    "confirmPack": "请确认已核对预览中的资料。后续资料变更会取消本次确认，需要重新确认。",
    "demoPack": "演示资料",
    "draftPack": "待最终确认",
    "loadTasksFailed": "未能读取任务，请重试。",
    "clearFilters": "清除待办筛选",
    "assignmentsTitle": "款式负责人",
    "assignmentsDesc": "为已准备好的委托书指定四位核心负责人，任务会同时显示在对应人员的任务列表中。",
    "testViewEnded": "测试视角已结束，已返回管理员。测试期内可重新选择人员。",
    "taskNotifications": "待办提醒",
    "pendingCount": "有 {count} 个款式需要处理",
    "allTasks": "查看全部任务",
    "trimPreview": "查看辅料 {code} 图片",
    "noTaskAccess": "当前账号尚未配置业务角色或委托书查看权限，请联系管理员。",
    "nextPlan": "按需调整款式负责人",
    "nextReview": "审核设计资料",
    "orderLookupReady": "订货会资料读取已配置，仍需取数验证。",
    "orderLookupMissing": "订货会资料读取尚缺连接资料，暂不可用。"
  }
};
